// The metadata row behind a /:subtype/:city page (city, state, coordinates,
// SEO tags). CitywisePage and Views both need it on first load — Views for the
// coordinates of its first listings fetch — so the request is shared.
import axiosInst from "@/utils/axiosinstance";

const cache = new Map();

export function citywisePageName(subtype, city) {
  return `/${subtype || ""}/${city || ""}`.toLowerCase().replace(/\/+$/, "");
}

/** Resolves to the metadata row, or null when the page has none. */
export function fetchCitywiseMeta(pageName) {
  if (!cache.has(pageName)) {
    const request = axiosInst
      .get("/api/citywise-metadata", { params: { pageName } })
      .then((res) => (res.data?.data || [])[0] || null)
      .catch(() => {
        cache.delete(pageName); // let a later visit retry
        return null;
      });
    cache.set(pageName, request);
  }
  return cache.get(pageName);
}

/**
 * "edison-township-nj" → "Edison Township, NJ". Only the fallback label for a
 * page without coordinates: geocoders read "Edison Township Nj" as a street
 * or a different town, so the state code must look like one.
 */
export function cityLabelFromSlug(slug) {
  const words = String(slug || "").split("-").filter(Boolean);
  if (!words.length) return "";
  const titled = (w) => w.charAt(0).toUpperCase() + w.slice(1);
  const last = words[words.length - 1];
  if (words.length > 1 && last.length === 2) {
    return `${words.slice(0, -1).map(titled).join(" ")}, ${last.toUpperCase()}`;
  }
  return words.map(titled).join(" ");
}
